import { PublicWorkspaceFragment, WorkspaceMinimalFragment } from 'gqlTypes'

type Workspace = Partial<
  Pick<
    WorkspaceMinimalFragment | PublicWorkspaceFragment,
    'userIsOwner' | 'type'
  >
>

export const isPersonalWorkspace = (workspace: Workspace = {}) =>
  workspace?.type === 'PERSONAL' && workspace?.userIsOwner

export const isGuestWorkspaces = (workspace: WorkspaceMinimalFragment) =>
  workspace.userRole === 'GUEST'

export const isMemberWorkspace = (workspace: WorkspaceMinimalFragment) =>
  !isPersonalWorkspace(workspace) && !isGuestWorkspaces(workspace)

export const getPersonalWorkspace = (
  workspaces: WorkspaceMinimalFragment[] = []
) => workspaces.find(isPersonalWorkspace)

export const getMemberWorkspaces = (
  workspaces: WorkspaceMinimalFragment[] = []
) => workspaces.filter(isMemberWorkspace)

export const getGuestWorkspaces = (
  workspaces: WorkspaceMinimalFragment[] = []
) => workspaces.filter(isGuestWorkspaces)
